import React from 'react'
import GCMaterialListPage from './GCMaterialsListPage'
import CreateGCMaterialPage from './CreateGCMaterialsPage'
import GCMaterialDetailPage from './GCMaterialsDetailPage'

const GCMaterialRoutes = [
  {
    breadcrumb: 'GC Material List',
    path: '',
    element: <GCMaterialListPage />,
    children: [],
  },
  {
    breadcrumb: 'Create GC Material ',
    path: 'create',
    element: <CreateGCMaterialPage />,
  },
  {
    breadcrumb: 'GC Material Detail',
    path: ':id',
    element: <GCMaterialDetailPage />,
  },
]

export default GCMaterialRoutes
